import React from "react";
import { Star, StarHalf } from "lucide-react";
import { getRating } from "@/lib/ratings";

export default function Stars({ slug, size = 14, showCount = true }) {
  const { stars, reviews } = getRating(slug);
  const full = Math.floor(stars);
  const half = stars % 1 !== 0;
  return (
    <div className="flex items-center gap-1.5" data-testid={`rating-${slug}`}>
      <div className="flex items-center gap-0.5 text-[#D4AF37]">
        {Array.from({ length: full }).map((_, i) => (
          <Star key={i} size={size} fill="currentColor" strokeWidth={0} />
        ))}
        {half && <StarHalf size={size} fill="currentColor" strokeWidth={0} />}
        {Array.from({ length: 5 - full - (half ? 1 : 0) }).map((_, i) => (
          <Star key={`e${i}`} size={size} className="text-[#D8C9AC]" fill="currentColor" strokeWidth={0} />
        ))}
      </div>
      {showCount && (
        <span className="text-xs font-medium text-[#6B5B45]">
          {stars} · {reviews.toLocaleString("en-IN")} reviews
        </span>
      )}
    </div>
  );
}
